import {useCommunityInfo} from "../../data/slsOrdSource";
import {ISlsOrdResponse} from "../../kova/slsordClient";
import React, {PropsWithChildren, useContext} from "react";



const CommunityDataContext = React.createContext<ISlsOrdResponse|null>(null);

export function useCommunityData() {
    return useContext(CommunityDataContext);
}

export const CommunityDataLoader: React.FC<PropsWithChildren> = (props) => {

    const { communityInfo } = useCommunityInfo()

    return <CommunityDataContext.Provider value={communityInfo}>{props.children}</CommunityDataContext.Provider>
}